import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { environment } from 'src/environments/environment.development';
import { customer, employee, modules, projects } from './interfaces';

@Injectable({
  providedIn: 'root',
})
export class ReportsService {
  private _loadingSrc = new BehaviorSubject<boolean>(false);
  public loading$: Observable<boolean>;
  private _getProjectsReports = `${environment.base_url}/api/NewReports/GetProjectReports`;
  private _getModulesReports = `${environment.base_url}/api/NewReports/GetModulesReports`;
  private _getEmployeesReports = `${environment.base_url}/api/NewReports/GetEmployeeData`;
  private _getCustomersReports = `${environment.base_url}/api/NewReports/GetCustomerReports`;

  public get loading() {
    return this._loadingSrc.value;
  }
  public set loading(val: boolean) {
    this._loadingSrc.next(val);
  }

  public _employee: any[] = [
    {
      id: 'd24d1574-e4fc-4649-ec9e-08dbb6897026',
      name: 'Tahir Aziz',
      email: 'tahir@innovadorsolutions.com',
      profilePic: 'Files\\User\\User3831_12192023103746.png',
      cost: 0,
      type: 'admin',
    },
    {
      id: '2725de3a-5737-4701-4cec-08dbb68b8090',
      name: 'Faisal Rafique',
      email: 'faisal@innovadorsolutions.com',
      profilePic: 'Files\\User\\User3233_12192023105227.png',
      cost: 250,
      type: 'leader',
    },
    {
      id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
      name: 'Talha Rajpar',
      email: 'molabux@innovadorsolutions.com',
      profilePic: 'Files/User/User9041_12192023105500.png',
      cost: 145,
      type: 'developer',
    },
    {
      id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
      name: 'Hammad Zafar',
      email: 'hammadzafar@innovadorsolutions.com',
      profilePic: 'Files\\User\\User9031_12192023103718.png',
      cost: 166,
      type: 'developer',
    },
    {
      id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
      name: 'Abdur Rehman',
      email: 'abdurrehman@innovadorsolutions.com',
      profilePic: 'Files\\User\\User8797_12192023103619.jpg',
      cost: 145,
      type: 'developer',
    },
    {
      id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
      name: 'Muhammad Muammar',
      email: 'muammar@innovadorsolutions.com',
      profilePic: 'Files\\User\\User6752_12192023110932.png',
      cost: 208,
      type: 'developer',
    },
    {
      id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
      name: 'Junaid Ashraf',
      email: 'junaid@innovadorsolutions.com',
      profilePic: 'Files/User/User8697_12192023111059.jpg',
      cost: 120,
      type: 'developer',
    },
    {
      id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
      name: 'Syed Asad',
      email: 'asad@innovadorsolutions.com',
      profilePic: 'Files/User/User8758_12192023103648.png',
      cost: 0,
      type: 'manager',
    },
    {
      id: '6a2406a1-4486-4104-ce95-08dbd4b6e92b',
      name: 'Iqbal Yousuf',
      email: 'iyousuf@innovadorsolutions.com',
      profilePic: 'Files\\User\\User2794_12192023103546.jpg',
      cost: 0,
      type: 'management',
    },
  ];
  public _customer: any[] = [
    {
      id: '216f4886-0ede-40b1-d0d7-08dbd40b620c',
      name: 'Bay View High School',
      companyLogo: 'Files/ProjectFiles/bvhs.png',
      ticketCount: 4,
    },
    {
      id: '7a3ff724-4298-43ee-5691-08dbd44694bb',
      name: 'Aptech Learning',
      companyLogo: 'Files/ProjectFiles/al.png',
      ticketCount: 0,
    },
    {
      id: '0d8a06dc-9fc6-4fc4-bd17-08dbe699e237',
      name: 'Innovador Solutions',
      companyLogo: 'Files/ProjectFiles/is.png',
      ticketCount: 6,
    },
    // {
    //   id: 'c75a2b72-a526-4e43-b1ac-08dbe8258662',
    //   name: 'Huzaifa',
    //   companyLogo: '',
    //   ticketCount: 0,
    // },
    // {
    //   id: 'b475cb91-4334-4191-b1ad-08dbe8258662',
    //   name: 'Juanid Ashraf',
    //   companyLogo: '',
    //   ticketCount: 1,
    // },
    // {
    //   id: '2af6b6bc-8603-45c1-b1ae-08dbe8258662',
    //   name: 'Molabux',
    //   companyLogo: '',
    //   ticketCount: 0,
    // },
    // {
    //   id: '3defe4c0-1806-48e3-b1af-08dbe8258662',
    //   name: 'Test',
    //   companyLogo: 'Files\\Customer\\Customer1839_11202023154855.jpg',
    //   ticketCount: 3,
    // },
  ];
  public _projects: any[] = [
    {
      id: '4dbfb504-f1e8-4aff-5404-08dbd4090a42',
      title: 'iSchool',
      logo: 'Files/ProjectFiles/i.png',
      customers:
        '[{"Id":"216F4886-0EDE-40B1-D0D7-08DBD40B620C"},{"Id":"7A3FF724-4298-43EE-5691-08DBD44694BB"},{"Id":"0D8A06DC-9FC6-4FC4-BD17-08DBE699E237"}]',
    },
    {
      id: '3952091f-4338-4328-bfc4-08dbd42cb81a',
      title: 'iSchool Mobile App',
      logo: 'Files/ProjectFiles/i.png',
      customers:
        '[{"Id":"216F4886-0EDE-40B1-D0D7-08DBD40B620C"},{"Id":"B475CB91-4334-4191-B1AD-08DBE8258662"},{"Id":"3DEFE4C0-1806-48E3-B1AF-08DBE8258662"}]',
    },
    {
      id: '65813f19-f917-4157-bfc5-08dbd42cb81a',
      title: 'iSchool Fee Module',
      logo: 'Files/ProjectFiles/i.png',
      customers:
        '[{"Id":"0D8A06DC-9FC6-4FC4-BD17-08DBE699E237"},{"Id":"C75A2B72-A526-4E43-B1AC-08DBE8258662"},{"Id":"B475CB91-4334-4191-B1AD-08DBE8258662"},{"Id":"2AF6B6BC-8603-45C1-B1AE-08DBE8258662"}]',
    },
    {
      id: 'd5d71f01-5775-4045-bfc6-08dbd42cb81a',
      title: 'HR360 Cloud',
      logo: 'Files/ProjectFiles/360.jpg',
      customers:
        '[{"Id":"3DEFE4C0-1806-48E3-B1AF-08DBE8258662"},{"Id":"B475CB91-4334-4191-B1AD-08DBE8258662"},{"Id":"C75A2B72-A526-4E43-B1AC-08DBE8258662"},{"Id":"0D8A06DC-9FC6-4FC4-BD17-08DBE699E237"}]',
    },
    {
      id: '0baafbae-d812-4003-bfc7-08dbd42cb81a',
      title: 'Aptech Learning Website',
      logo: 'Files/ProjectFiles/al.png',
      customers:
        '[{"Id":"7A3FF724-4298-43EE-5691-08DBD44694BB"},{"Id":"2AF6B6BC-8603-45C1-B1AE-08DBE8258662"},{"Id":"B475CB91-4334-4191-B1AD-08DBE8258662"}]',
    },
    {
      id: '267f2f9d-d863-4494-bfc8-08dbd42cb81a',
      title: 'Aptech Vision',
      logo: 'Files/ProjectFiles/vision.png',
      customers: '[{"Id":"2AF6B6BC-8603-45C1-B1AE-08DBE8258662"}]',
    },
    {
      id: 'f1a2d461-affa-49cd-bfcb-08dbd42cb81a',
      title: 'Aptech CAH System',
      logo: 'Files/ProjectFiles/alc.png',
      customers: '[]',
    },
    {
      id: '32d041c0-5117-4e5f-bfcc-08dbd42cb81a',
      title: 'Innovador Solutions Website',
      logo: 'Files/ProjectFiles/is.png',
      customers: '[]',
    },
    {
      id: '0928b1ed-0262-4cb2-bfcd-08dbd42cb81a',
      title: 'iSchool Website',
      logo: 'Files/ProjectFiles/i.png',
      customers: '[]',
    },
    {
      id: 'bc4b3ba8-24eb-481d-bfce-08dbd42cb81a',
      title: 'HR360 website',
      logo: 'Files/ProjectFiles/360.jpg',
      customers: '[]',
    },
    // {
    //   id: 'b170d9fd-dfe8-4a05-bfcf-08dbd42cb81a',
    //   title: 'TCF Demo',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '8f8244fe-faa0-410f-f71b-08dbd4b5f902',
    //   title: 'Process point',
    //   logo: '',
    //   customers: '[]',
    // },
    {
      id: '3acd05e6-9b4f-4503-f71c-08dbd4b5f902',
      title: 'Tech Shop',
      logo: 'Files/ProjectFiles/aassan.png',
      customers: '[]',
    },
    // {
    //   id: '0bf5aa28-14c6-4773-4706-08dbd75274f0',
    //   title: 'Freelancing',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '16ece40b-9d21-4326-26ae-08dbe9598ca6',
    //   title: 'iSchool',
    //   logo: '',
    //   customers: '[{"Id":"216F4886-0EDE-40B1-D0D7-08DBD40B620C"}]',
    // },
    // {
    //   id: 'b56fccb7-792d-4c61-26af-08dbe9598ca6',
    //   title: 'iSchool Mobile App',
    //   logo: '',
    //   customers: '[{"Id":"216F4886-0EDE-40B1-D0D7-08DBD40B620C"}]',
    // },
    // {
    //   id: 'ca759d18-d93e-434b-3dd6-08dbebb9b84d',
    //   title: 'iSchool Fee Module',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '1ba8c474-ef4c-4a8d-3dd7-08dbebb9b84d',
    //   title: 'Aptech Education Website',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '2e1e1503-aafc-4338-3dd8-08dbebb9b84d',
    //   title: 'iSchool.me',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: 'd2ddd015-35f9-42f8-3dd9-08dbebb9b84d',
    //   title: 'Aptech CAH Panel',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: 'ad69b9b0-fd1b-4c3f-3dda-08dbebb9b84d',
    //   title: 'Aptech Vision',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: 'd5a1ff5d-a2d7-4124-3ddb-08dbebb9b84d',
    //   title: 'Asaan App',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '4cf641ec-89fd-4305-3ddc-08dbebb9b84d',
    //   title: 'HR360 Cloud',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: 'ba8077eb-6fb3-4c46-3ddd-08dbebb9b84d',
    //   title: 'Innovador Solutions Website',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '187941d5-417b-4821-3dde-08dbebb9b84d',
    //   title: 'iSchool Website',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '4984e3fe-41d6-4c1a-3ddf-08dbebb9b84d',
    //   title: 'HR360 Website',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '5ec55570-9a1a-49b0-3de0-08dbebb9b84d',
    //   title: 'Tech Shop',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: 'eece42ae-1382-40a7-3de1-08dbebb9b84d',
    //   title: 'Form Builder',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: 'de65614b-5c39-4e40-d740-08dbf56f2e6e',
    //   title: 'Ut corporis et lorem',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '12e84b69-5622-4bf7-da94-08dbf583e20d',
    //   title: 'iSchool',
    //   logo: '',
    //   customers: '[]',
    // },
    // {
    //   id: '275f30ce-3ce7-4774-da95-08dbf583e20d',
    //   title: 'Et eos cupiditate ea',
    //   logo: '',
    //   customers: '[]',
    // },
  ];
  public _modules: any[] = [
    {
      id: '0a80c637-d712-43f9-e7d0-08dbd409b1a7',
      title: 'Academics & Learning',
      projectId: '4DBFB504-F1E8-4AFF-5404-08DBD4090A42',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'ca6f2abc-ec6b-4fcb-e7d1-08dbd409b1a7',
      title: 'Communication',
      projectId: '4DBFB504-F1E8-4AFF-5404-08DBD4090A42',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '01cddace-23d9-406a-e7d2-08dbd409b1a7',
      title: 'Administration',
      projectId: '4DBFB504-F1E8-4AFF-5404-08DBD4090A42',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '898ac5d5-9405-4155-64f7-08dbd4b31254',
      title: 'Aptech Education Webiste',
      projectId: '0BAAFBAE-D812-4003-BFC7-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'bc6491b6-9852-4178-64f8-08dbd4b31254',
      title: 'Aptech Website Learning Admin Panel',
      projectId: '0BAAFBAE-D812-4003-BFC7-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'ff601ec9-69de-4d69-64f9-08dbd4b31254',
      title: 'Form Builder',
      projectId: '8F8244FE-FAA0-410F-F71B-08DBD4B5F902',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '2ab0233b-cd95-4ff5-64fa-08dbd4b31254',
      title: 'Aptech Vision Mobile App',
      projectId: '267F2F9D-D863-4494-BFC8-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '17d1c086-d3d7-4ea9-64fb-08dbd4b31254',
      title: 'Aptech Vision Portal',
      projectId: '267F2F9D-D863-4494-BFC8-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '55eb0e86-3d37-4878-582a-08dbd7528ce3',
      title: 'Fiverr',
      projectId: '0BF5AA28-14C6-4773-4706-08DBD75274F0',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'fc6557f1-8ca0-47bd-582b-08dbd7528ce3',
      title: 'Upwork',
      projectId: '0BF5AA28-14C6-4773-4706-08DBD75274F0',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '6c9ad6fa-3fc2-4e07-582c-08dbd7528ce3',
      title: 'Guru',
      projectId: '0BF5AA28-14C6-4773-4706-08DBD75274F0',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '6d50da11-8dcb-4425-582d-08dbd7528ce3',
      title: 'peopleperhour',
      projectId: '0BF5AA28-14C6-4773-4706-08DBD75274F0',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '04eaa34d-0061-4268-582e-08dbd7528ce3',
      title: 'Freelancer',
      projectId: '0BF5AA28-14C6-4773-4706-08DBD75274F0',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'dbf777c0-a066-41d0-abba-08dbe50b6d00',
      title: 'Notice Board',
      projectId: '3952091F-4338-4328-BFC4-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'a305c417-4cd0-4934-abbb-08dbe50b6d00',
      title: 'Attendance',
      projectId: '3952091F-4338-4328-BFC4-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'bfbb07f4-408e-40b3-abbc-08dbe50b6d00',
      title: 'Report Card',
      projectId: '3952091F-4338-4328-BFC4-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'd8c7746a-72bc-4990-7ed0-08dbea81d616',
      title: 'Repudiandae explicab',
      projectId: 'F1A2D461-AFFA-49CD-BFCB-08DBD42CB81A',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '412499f9-c4c1-44c5-34f2-08dbeb93005a',
      title: 'Communication',
      projectId: '16ECE40B-9D21-4326-26AE-08DBE9598CA6',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '39dbe496-8fde-4c48-34f3-08dbeb93005a',
      title: 'Academics & Learning',
      projectId: '16ECE40B-9D21-4326-26AE-08DBE9598CA6',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '7617213c-5664-4e2f-34f4-08dbeb93005a',
      title: 'Administration',
      projectId: '16ECE40B-9D21-4326-26AE-08DBE9598CA6',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'fd740ccb-b1e2-4045-34f5-08dbeb93005a',
      title: 'Dashboard',
      projectId: '54045A65-714E-4EED-26B0-08DBE9598CA6',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '0546e363-073c-45bf-34f6-08dbeb93005a',
      title: 'Classes',
      projectId: '54045A65-714E-4EED-26B0-08DBE9598CA6',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '93f22a47-bf49-465f-34f7-08dbeb93005a',
      title: 'Sections',
      projectId: '54045A65-714E-4EED-26B0-08DBE9598CA6',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'b9655d92-11a1-4116-34f8-08dbeb93005a',
      title: 'Students',
      projectId: '54045A65-714E-4EED-26B0-08DBE9598CA6',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'e2b7764c-6e43-4d5d-34f9-08dbeb93005a',
      title: 'Fee Collections',
      projectId: 'CA759D18-D93E-434B-3DD6-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '7c6c5869-3282-4567-34fa-08dbeb93005a',
      title: 'Reports',
      projectId: 'CA759D18-D93E-434B-3DD6-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'ca9ed559-23a9-4e75-2671-08dbebba3964',
      title: 'System Settings',
      projectId: 'CA759D18-D93E-434B-3DD6-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '15c805f5-977a-4852-2672-08dbebba3964',
      title: 'Home',
      projectId: '1BA8C474-EF4C-4A8D-3DD7-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '43748b68-56dd-48f3-2673-08dbebba3964',
      title: 'About Aptech',
      projectId: '1BA8C474-EF4C-4A8D-3DD7-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '83e2d741-37ad-4a03-2674-08dbebba3964',
      title: 'New & Events',
      projectId: '1BA8C474-EF4C-4A8D-3DD7-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '47179410-3d30-4ec5-2675-08dbebba3964',
      title: 'Partners with us',
      projectId: '1BA8C474-EF4C-4A8D-3DD7-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '17a41410-a34f-42dd-2676-08dbebba3964',
      title: 'Alumni',
      projectId: '1BA8C474-EF4C-4A8D-3DD7-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'a1585b16-be5e-4970-2677-08dbebba3964',
      title: 'Placement',
      projectId: '1BA8C474-EF4C-4A8D-3DD7-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '87a83696-1824-4c00-2678-08dbebba3964',
      title: 'Location',
      projectId: '1BA8C474-EF4C-4A8D-3DD7-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: '4a29f3cd-cdea-48a1-2679-08dbebba3964',
      title: 'Mobile App',
      projectId: 'AD69B9B0-FD1B-4C3F-3DDA-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
    {
      id: 'c3e87bf3-507f-4c30-267a-08dbebba3964',
      title: 'Admin Panel',
      projectId: 'AD69B9B0-FD1B-4C3F-3DDA-08DBEBB9B84D',
      employees: [
        {
          id: '2725de3a-5737-4701-4cec-08dbb68b8090',
          name: 'Faisal',
          hours: 7.935277769,
        },
        {
          id: '68231afe-f9fb-403b-4ced-08dbb68b8090',
          name: 'Talha',
          hours: 7.631666658,
        },
        {
          id: 'c9c19a8b-b6f7-483d-4cee-08dbb68b8090',
          name: 'Hammad',
          hours: 7.631666658,
        },
        {
          id: 'c53ddeb7-3017-402b-4cef-08dbb68b8090',
          name: 'Abdur',
          hours: 7.668055542,
        },
        {
          id: '23604328-8c8f-4bc1-4cf0-08dbb68b8090',
          name: 'Muhammad',
          hours: 7.695555546,
        },
        {
          id: 'c5634153-7bfc-40d6-4cf1-08dbb68b8090',
          name: 'Junaid',
          hours: 7.631666658,
        },
        {
          id: 'dad74f35-297c-4596-b677-08dbb68ea29f',
          name: 'Syed',
          hours: 1.271944443,
        },
      ],
      moduleEmployees: '',
    },
  ];

  public employee: employee[] = [];
  public customer: customer[] = [];
  public projects: projects[] = [];
  public modules: modules[] = [];

  constructor(private _http: HttpClient) {
    this.loading$ = this._loadingSrc.asObservable();
    this.loading = true;

    this._GetEmployee(true)
      .pipe(
        map((employees) =>
          employees.map((employee) => {
            employee.id = employee.id.toLowerCase();
            if (employee.profilePic) {
              employee.profilePic = `${environment.base_url}/${employee.profilePic}`;
            }
            return employee;
          })
        )
      )
      .subscribe({
        next: (emp) => {
          this.employee = emp;
          this._GetCustomer(true)
            .pipe(
              map((customers) =>
                customers.map((customer) => {
                  customer.id = customer.id.toLowerCase();
                  if (customer.companyLogo) {
                    customer.companyLogo = `${environment.base_url}/${customer.companyLogo}`;
                  }
                  return customer;
                })
              )
            )
            .subscribe({
              next: (cs) => {
                this.customer = cs;

                this._GetProjects(true)
                  .pipe(
                    map((projects) => {
                      return projects.map((project) => {
                        project.customers = JSON.parse(
                          project.customers as string
                        );
                        (project.customers as Array<{ Id: string }>).forEach(
                          (customer) => {
                            customer.Id = customer.Id.toLowerCase();
                          }
                        );
                        if (project.logo) {
                          project.logo = `${environment.base_url}/${project.logo}`;
                        }
                        return project;
                      });
                    })
                  )
                  .subscribe({
                    next: (p) => {
                      this.projects = p;

                      this._GetModules(true)
                        .pipe(
                          map((modules) =>
                            modules.map((module) => {
                              module.id = module.id.toLowerCase();
                              module.projectId = module.projectId.toLowerCase();
                              return module;
                            })
                          )
                        )
                        .subscribe({
                          next: (m) => {
                            this.modules = m;
                            this.loading = false;
                          },
                        });
                    },
                  });
              },
            });
        },
      });
  }
  private _GetEmployee(s: boolean): Observable<employee[]> {
    if (s)
      return new BehaviorSubject<employee[]>(this._employee).asObservable();
    else
      return this._http.get<employee[]>(
        `${environment.base_url}/api/Reports/GetEmployeeReportData`,
        {
          responseType: 'json',
        }
      );
  }
  private _GetCustomer(s: boolean): Observable<customer[]> {
    if (s)
      return new BehaviorSubject<customer[]>(this._customer).asObservable();
    else
      return this._http.get<customer[]>(
        `${environment.base_url}/api/Reports/GetCustomerReportData`
      );
  }
  private _GetProjects(s: boolean): Observable<projects[]> {
    if (s)
      return new BehaviorSubject<projects[]>(this._projects).asObservable();
    else
      return this._http.get<projects[]>(
        `${environment.base_url}/api/Reports/GetProjectReportData`
      );
  }
  private _GetModules(s: boolean): Observable<modules[]> {
    if (s) return new BehaviorSubject<modules[]>(this._modules).asObservable();
    else
      return this._http.get<modules[]>(
        `${environment.base_url}/api/Reports/GetModuleReportDataWithEmp`
      );
  }

  GetProjectsReports(id?: string) {
    const url = id
      ? `${this._getProjectsReports}?customerId=${id}`
      : `${this._getProjectsReports}`;
    return this._http
      .get<any[]>(url, {
        responseType: 'json',
      })
      .pipe(
        map((projects) => {
          projects.forEach((x) => {
            x.logo = `${environment.base_url}/${x.logo}`;
            x.hours = parseFloat(x.hours.toFixed(2));
            x.cost = parseFloat(x.cost.toFixed(2));
          });
          if (id) return projects.filter((x) => x.customerId == id);
          else return projects;
        })
      );
  }
  GetModulesReports(id?: string) {
    const url = id
      ? `${this._getModulesReports}?projectId=${id}`
      : `${this._getModulesReports}`;
    return this._http
      .get<any[]>(url, {
        responseType: 'json',
      })
      .pipe(
        map((module) => {
          module.forEach((x) => {
            x.projectLogo = `${environment.base_url}/${x.projectLogo}`;
            x.hours = parseFloat(x.hours.toFixed(2));
            x.cost = parseFloat(x.cost.toFixed(2));
          });
          if (id) return module.filter((x) => x.projectId == id);
          else return module;
        })
      );
  }
  GetEmployeeReports(projectId?: string, moduleId?: string) {
    const url = projectId
      ? `${this._getEmployeesReports}?projectId=${projectId}`
      : moduleId
      ? `${this._getEmployeesReports}?moduleId=${moduleId}`
      : `${this._getEmployeesReports}`;
    return this._http
      .get<any[]>(url, {
        responseType: 'json',
      })
      .pipe(
        map((team) => {
          team.forEach((person) => {
            //   person.projectLogo = `${environment.base_url}/${person.projectLogo}`;
            person.profilePic = `${environment.base_url}/${person.profilePic}`;
            person.expend = false;
            // console.log(person.projects);
            person.projects.forEach((p: any) => {
              p.expend = false;
            });

            //   person.hours = parseFloat(person.hours.toFixed(2));
            //   person.cost = parseFloat(person.cost.toFixed(2));
          });
          return team;
        })
      );
  }
  GetCustomersReports() {
    return this._http
      .get<any[]>(this._getCustomersReports, {
        responseType: 'json',
      })
      .pipe(
        map((customer) => {
          customer.forEach((x) => {
            x.companyLogo = `${environment.base_url}/${x.companyLogo}`;
          });
          return customer;
        })
      );
  }
}
